/* BG-READABLE-OPTIONS-V2 2026-11-03. Target-specific engraving details persist
   as ordinary Shopify line properties through cart, checkout and orders.
   Legacy _bg_* selection keys, carrier IDs and amounts remain authoritative.
   Rollback: restore the backed-up asset and bg-options-body/cart snippets. */
(function () {
  'use strict';
  if (window.__bgReadableOptionsV2) return;
  window.__bgReadableOptionsV2 = true;
  var PREFIX = 'Customization · ', CONTEXT = '_bg_display_context';
  var LEGACY = /^(Engraving – |Engraving Font – )/;
  var LEGACY_NAMED={'flight-handle-engraving-text':'Flight Handle','bottle-box-engraving-text':'Wooden Bottle Box','wooden-gift-crate-text':'Wooden Gift Crate','custom-design-text':'Bottle Design Text','decanter-custom-design-text':'Decanter Design Text','hip-flask-custom-design-text':'Hip Flask Design Text','decanter-vintage-number':'Decanter Vintage Number'};
  function own(k) { return k.indexOf(PREFIX) === 0 || LEGACY.test(k); }
  function title(s) { return String(s).replace(/[_-]+/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); }); }
  function configs() {
    return Array.from(document.querySelectorAll('script[id^="bg-options-config-"]')).map(function (el) {
      try { return JSON.parse(el.textContent); } catch (_) { return null; }
    }).filter(Boolean);
  }
  function context(props, variant, form) {
    var saved = null;
    try { saved = JSON.parse(props[CONTEXT]); } catch (_) {}
    var all = configs(), found = all.filter(function (c) {
      return variant && (c.variant_ids || []).some(function (v) { return String(v) === String(variant); });
    });
    if (!found.length && saved && !/^\d+$/.test(String(variant || ''))) found=all.filter(function(c) { return String(saved.product_id)===String(c.product_id); });
    if (found.length===1 && saved && String(saved.product_id)!==String(found[0].product_id)) saved=null;
    if (!found.length && form) {
      var root = form.closest('[data-bg-options-root]');
      if (root) found = all.filter(function (c) { return root.id === 'bg-options-' + c.product_id; });
    }
    return {config: found.length === 1 ? found[0] : null,
      saved: saved && saved.version === 2 ? saved : null};
  }
  function target(key, primary) {
    var m;
    if (/^(bottle-(?:text|font|engraving|logo)|custom-design-text|engrave-additional-bottles)/.test(key)) return primary;
    if ((m = key.match(/^bottle-(\d+)-/))) return 'Bottle ' + m[1];
    if ((m = key.match(/^(?:included-glasses-(?:message-line|glass)|minis-flight-glass)-(\d+)/))) return 'Glass ' + m[1];
    if (/^(?:inc-old-fashioned|included-glasses)/.test(key)) return 'Included Glasses';
    if ((m = key.match(/^(old-fashioned|glencairn|wine|champagne|tequila)-(?:glass|flutes)-(\d+)/)))
      return title(m[1]) + ' Glass ' + m[2];
    if (/old-fashioned/.test(key)) return 'Old-Fashioned Glasses';
    if (/glencairn/.test(key)) return 'Glencairn Glasses';
    if (/^wine-/.test(key)) return 'Wine Glasses';
    if (/^champagne-/.test(key)) return 'Champagne Flutes';
    if (/^tequila-/.test(key)) return 'Tequila Flutes';
    if (/decanter/.test(key)) return 'Decanter';
    if (/hip-flask/.test(key)) return 'Hip Flask';
    if (/flight-handle/.test(key)) return 'Flight Handle';
    if (/^(?:bottle-box|wooden-bottle-box)/.test(key)) return 'Wooden Bottle Box';
    if (/^(?:wooden-gift-crate|included-box)/.test(key)) return 'Wooden Gift Box';
    if (/greeting-card/.test(key)) return 'Greeting Card';
    if (/gift-wrap/.test(key)) return 'Gift Wrap';
    return 'Accessories';
  }
  function field(key, opt) {
    var m;
    if (/-font$/.test(key)) return 'Font';
    if (/-finish$/.test(key)) return 'Finish';
    if (/-design-type$/.test(key)) return 'Engraving Type';
    if (/_file_url$/.test(key) || opt && opt.input_type === 'file_upload') return 'Artwork File';
    if ((m = key.match(/(?:text-line|smooth-line)-(\d+)$/))) return 'Text Line ' + m[1];
    if (/initials$/.test(key) || /included-glasses-message-line-/.test(key)) return 'Initials';
    if (/premium-greeting-card-message$/.test(key)) return 'Message';
    if (/-text$/.test(key)) return /custom-design/.test(key) ? 'Design Text' : 'Text';
    if (/vintage-number$/.test(key)) return 'Vintage Number';
    if (/custom-design$/.test(key)) return 'Design';
    return opt && opt.label ? opt.label.replace(/\s*\([^)]*\)/g, '').trim() : title(key);
  }
  function normalizeConfig(el) {
    if (!el || el.getAttribute('data-bg-readable') === '2') return;
    var c;
    try { c = JSON.parse(el.textContent); } catch (_) { return; }
    if (c.primary_target && c.primary_target !== 'Bottle 1') {
      (c.groups || []).forEach(function (g) {
        if (g.key !== 'bottle-engraving') return;
        (g.options || []).forEach(function (o) {
          if (o.key === 'engrave-additional-bottles') {
            // Not a bottle bundle; this unrelated control cannot identify a glass.
            o.condition_rule = {logic:'AND', conditions:[{type:'leaf', source_key:'__bg_no_bottle_on_glassware',operator:'equals',value:'never'}]};
          } else if (target(o.key, c.primary_target) === c.primary_target) {
            o.label = c.primary_target + ' — ' + field(o.key, o);
          }
          // Only the descriptive label changes. No choice value/amount/bridge key.
          (o.choices || []).forEach(function (ch) {
            if (ch.fee_rule && typeof ch.fee_rule.label === 'string')
              ch.fee_rule.label = ch.fee_rule.label.replace(/Bottle Engraving/gi, c.primary_target + ' Engraving');
          });
        });
      });
    }
    el.textContent = JSON.stringify(c);
    el.setAttribute('data-bg-readable', '2');
  }
  window.bgNormalizeEngravingConfig = normalizeConfig;
  function augment(props, variant, form) {
    if (!props || typeof props !== 'object' || !Object.prototype.hasOwnProperty.call(props, '_bg_option_set_handle')) return;
    var ctx = context(props, variant, form), cfg = ctx.config, saved = ctx.saved;
    var primary = cfg && cfg.primary_target || saved && saved.primary_target || 'Bottle 1';
    if (cfg && cfg.product_id) {
      saved = {version:2,product_id:cfg.product_id,primary_target:primary};
      props[CONTEXT] = JSON.stringify(saved);
    }
    var opts = {}, generated = [], seen = {}, old = {}, replaced = {};
    (cfg && cfg.groups || []).forEach(function (g) { (g.options || []).forEach(function (o) { opts[o.key] = o; }); });
    function legacyAliases(k,opt) {
      replaced['Engraving – '+title(k)]=true;
      if(opt && opt.label) replaced['Engraving – '+opt.label.replace(/\s*\(.*?\)\s*/g,' ').trim()]=true;
      if(/-font$/.test(k)) replaced['Engraving Font – '+title(k.replace(/-?(text-)?font$/,'').replace(/^select-/,''))]=true;
      if(LEGACY_NAMED[k]) replaced['Engraving – '+LEGACY_NAMED[k]]=true;
      var flight=k.match(/^minis-flight-glass-(\d)-text$/);
      if(flight) replaced['Engraving – Glass '+flight[1]]=true;
    }
    Object.keys(opts).forEach(function(k) { legacyAliases(k,opts[k]); });
    ['bottle-text-line-1','bottle-text-line-2','bottle-font','custom-design-text','decanter-text-line-1','decanter-text-line-2','decanter-font','hip-flask-text-line-1','hip-flask-text-line-2','hip-flask-text-font','flight-handle-engraving-text','bottle-box-engraving-text','wooden-gift-crate-text'].forEach(function(k) { legacyAliases(k); });
    Object.keys(LEGACY_NAMED).forEach(function(k) { legacyAliases(k); });
    for(var flightN=1;flightN<=9;flightN++) legacyAliases('minis-flight-glass-'+flightN+'-text');
    Object.keys(props).forEach(function (k) { if (own(k)) { old[k] = props[k]; delete props[k]; } });
    Object.keys(props).forEach(function (pk) {
      if (pk.indexOf('_bg_') !== 0) return;
      var k = pk.slice(4), value = props[pk], opt = opts[k] || opts[k.replace(/_file_url$/,'')];
      legacyAliases(k,opt);
      if (value == null || typeof value === 'object' || !String(value).trim()) return;
      if (/^(option_set_handle|selection_detail|fees|fee_|carrier|display_context)/.test(k)) return;
      var text = /_file_url$/.test(k) || opt && /^(text_line|textarea|file_upload)$/.test(opt.input_type) ||
        /(?:text(?:-line-\d+)?|initials|message|vintage-number|smooth-line-\d+)$/.test(k);
      var option = /(?:font|finish|design-type|custom-design)$/.test(k);
      if (!text && !option && !opt && !/^(gift-wrap|premium-cigars|cigar-accessories|chilling-options|glassware-flasks|wooden-flight-handle-with-3-glencairn-glasses)$/.test(k)) return;
      if (opt && opt.input_type==='heading') return;
      var human = String(value);
      (opt && opt.choices || []).forEach(function (ch) { if (String(ch.value) === human) human = ch.label || human; });
      if (!text && !opt) human = title(human);
      var group = target(k, primary), label = field(k, opt), name = PREFIX + group + ' · ' + label;
      // Stable semantic key resolves even duplicate legacy metadata labels.
      if (seen[name]) name += ' (' + k + ')';
      if (!opt && !text && Object.prototype.hasOwnProperty.call(old,name)) human=old[name];
      seen[name] = true;
      generated.push([group, name, human]);
    });
    generated.sort(function (a,b) { return a[0].localeCompare(b[0],undefined,{numeric:true}); });
    generated.forEach(function (row) { props[row[1]] = row[2]; });
    // Legacy merchant details without a regenerated source survive. V2 namespace
    // is ours: stale deselected V2 fields must disappear, not become new instructions.
    Object.keys(old).forEach(function (k) {
      if (LEGACY.test(k) && !replaced[k]) props[k] = old[k];
    });
  }
  function formVariant(fd) { var id=fd.get('id'); return id && String(id); }
  function augmentForm(fd, form) {
    var props={};
    fd.forEach(function (v,k) { var m=k.match(/^properties\[(.+)\]$/); if (m && typeof v==='string') props[m[1]]=v; });
    if (!Object.prototype.hasOwnProperty.call(props,'_bg_option_set_handle')) return fd;
    augment(props,formVariant(fd),form);
    var remove=[];
    fd.forEach(function (v,k) { var m=k.match(/^properties\[(.+)\]$/); if(m && typeof v==='string' && own(m[1])) remove.push(k); });
    remove.forEach(function (k) { fd.delete(k); });
    Object.keys(props).forEach(function (k) { if(own(k)||k===CONTEXT) fd.set('properties['+k+']',props[k]); });
    return fd;
  }
  function augmentJSON(str) {
    try {
      var b=JSON.parse(str);
      if (Array.isArray(b.items)) b.items.forEach(function (i) { augment(i.properties,i.id); });
      if (b.properties) augment(b.properties,b.id);
      return JSON.stringify(b);
    } catch (_) { return str; }
  }
  function body(b) {
    if (!b) return b;
    if (b instanceof FormData) return augmentForm(b);
    if (b instanceof URLSearchParams) return augmentForm(b);
    if (typeof b==='string') {
      if (b.trim().charAt(0)==='{') return augmentJSON(b);
      if (b.indexOf('properties')!==-1) return augmentForm(new URLSearchParams(b)).toString();
    }
    return b;
  }
  function hit(u) {
    try { var x=new URL(typeof u==='string'?u:u.url,location.href); return x.origin===location.origin && /\/cart\/(add|change)(\.js)?$/.test(x.pathname); }
    catch (_) { return false; }
  }
  var originalFetch=window.fetch;
  if (originalFetch) window.fetch=function (input,init) {
    var self=this;
    if (!hit(input)) return originalFetch.apply(self,arguments);
    if (init && init.body != null) {
      var next=Object.assign({},init,{body:body(init.body)});
      return originalFetch.call(self,input,next);
    }
    if (typeof Request!=='undefined' && input instanceof Request && !/^(GET|HEAD)$/.test(input.method)) {
      var request=new Request(input,init), copy=request.clone(), type=copy.headers.get('content-type')||'';
      var parsed=/multipart\/form-data/i.test(type)?copy.formData():copy.text();
      return parsed.then(function (b) {
        var nextBody=body(b), headers=new Headers(request.headers);
        if (nextBody instanceof FormData) headers.delete('content-type');
        return originalFetch.call(self,new Request(request,{body:nextBody,headers:headers}));
      });
    }
    return originalFetch.apply(self,arguments);
  };
  var open=XMLHttpRequest.prototype.open,send=XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open=function (m,u) { this.__bgReadableURL=u; return open.apply(this,arguments); };
  XMLHttpRequest.prototype.send=function (b) { return send.call(this,hit(this.__bgReadableURL)?body(b):b); };
  // Fires for new FormData(form), regular submit, requestSubmit and native .submit(),
  // including the engine's artwork route. File objects stay untouched.
  document.addEventListener('formdata',function (e) {
    if (e.target && /\/cart\/add(?:\.js)?(?:\?|$)/.test(e.target.action||'')) augmentForm(e.formData,e.target);
  },true);
  function labels() {
    configs().forEach(function(c) {
      if (!c.product_id || !c.primary_target || c.primary_target==='Bottle 1') return;
      var root=document.getElementById('bg-options-'+c.product_id);
      if (!root) return;
      root.querySelectorAll('.bg-field--heading').forEach(function(h) {
        if (/^Engrave Your Bottle$/i.test(h.textContent.trim())) h.textContent='Engrave Your '+c.primary_target;
      });
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',labels); else labels();
})();
